import { OnInit, TemplateRef } from '@angular/core';
import { RelatedService } from '../services/related.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
var RelatedComponent = /** @class */ (function () {
    function RelatedComponent(relatedService, modalService, router, globals, workspaceService) {
        this.relatedService = relatedService;
        this.modalService = modalService;
        this.router = router;
        this.globals = globals;
        this.workspaceService = workspaceService;
    }
    Object.defineProperty(RelatedComponent.prototype, "setDocumentList", {
        set: function (doc) {
            this.buildDocumentList(doc);
        },
        enumerable: true,
        configurable: true
    });
    RelatedComponent.prototype.getRelatedDocument = function (relationName, template) {
        var _this = this;
        this.relatedService.getRelatedDocuments(this.parentComponentId, relationName).subscribe(function (result) {
            _this.componentId = result;
            _this.relatedService.getRelationCard(_this.componentId).subscribe(function (data) {
                var config = {
                    keyboard: false,
                    ignoreBackdropClick: true,
                    class: 'modal-dialog-centered modal-related'
                };
                _this.modalRef = _this.modalService.show(template, config);
                _this.relatedDocumentObject = JSON.parse(data);
                _this.levels = _this.getLevels();
                _this.getLevels().forEach(function (element) {
                    _this.relatedService.getCardListDetail(_this.componentId, element.DocumentType).subscribe(function (detailResult) {
                        if (detailResult == "1") {
                            _this.refreshRelatedCard();
                        }
                    });
                });
            });
        });
    };
    RelatedComponent.prototype.refreshRelatedCard = function () {
        var _this = this;
        this.relatedService.getRelationCard(this.componentId).subscribe(function (data) {
            _this.relatedDocumentObject = JSON.parse(data);
        });
    };
    RelatedComponent.prototype.onDecline = function () {
        this.modalRef.hide();
        document.body.classList.remove('modal-open');
    };
    RelatedComponent.prototype.getLevels = function () {
        return this.relatedDocumentObject.LevelMapping.filter(function (x) { return x.DisplaySummaryType != ""; }).sort(function (a, b) {
            if (a.Sequence > b.Sequence) {
                return 1;
            }
            else if (a.Sequence < b.Sequence) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    RelatedComponent.prototype.getLevelDocument = function (docType) {
        if (this.relatedDocumentObject.Levels[docType].length > 0) {
            return this.relatedDocumentObject.Levels[docType];
        }
    };
    RelatedComponent.prototype.highlightDirectRelated = function (docType, docId) {
        var _this = this;
        this.clearAllHighlights();
        this.relatedService.selectHighlightCard(this.componentId, docType, docId).subscribe(function (result) {
            var highlightDoc = JSON.parse(result);
            _this.getLevels().forEach(function (element) {
                highlightDoc[element.DocumentType].forEach(function (item) {
                    _this.selectedDoc = docId;
                    _this.relatedDocumentObject.Levels[element.DocumentType].find(function (doc) { return doc.DocumentId == item; }).Highlight = true;
                });
            });
        });
    };
    RelatedComponent.prototype.showRelatedDocument = function (docType, docId) {
        var _this = this;
        this.relatedService.selectCard(this.componentId, docType, docId).subscribe(function (result) {
            // this.modalRef.hide();
            // this.router.navigate(["detail", result]);
            if (result) {
                _this.openDetailPopup(result, "");
            }
        });
    };
    RelatedComponent.prototype.openDetailPopup = function (event, title) {
        var _this = this;
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-detail',
            initialState: {
                componentId: event,
                title: title
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalService.show(DetailPopupComponent, config);
    };
    RelatedComponent.prototype.clearAllHighlights = function () {
        var _this = this;
        this.getLevels().forEach(function (element) {
            _this.relatedDocumentObject.Levels[element.DocumentType].forEach(function (subElement) {
                subElement.Highlight = false;
            });
        });
    };
    RelatedComponent.prototype.ngOnInit = function () { };
    RelatedComponent.prototype.buildDocumentList = function (dirtyList) {
        // dirtyList = "(Bank:Compare)|(Doc:Additional Info)|LO:Accept Offer|";
        var _this = this;
        this.documentList = [];
        var index = 0;
        dirtyList.split('|').forEach(function (document) {
            if (document.replace('(', '').replace(')', '') == "") {
                _this.documentList[index - 1].IsFullSelected = true;
            }
            else {
                var doc = new Document();
                doc.ImageName = document.split(':')[0].replace('(', '').replace(')', '');
                doc.Title = document.split(':')[1] ? document.split(':')[1].replace('(', '').replace(')', '') : "";
                doc.IsSelected = document.indexOf('(') > -1;
                if (doc.IsSelected && _this.documentList[index - 1]) {
                    _this.documentList[index - 1].IsFullSelected = true;
                }
                _this.documentList.push(doc);
            }
            index++;
        });
        // console.log(this.documentList);
    };
    return RelatedComponent;
}());
export { RelatedComponent };
var Document = /** @class */ (function () {
    function Document() {
    }
    return Document;
}());
export { Document };
